/* Wool-e 2026 theme helpers. Loaded with defer; safe to include more than once. */
(function () {
  if (window.__woolE) return;
  window.__woolE = true;

  /* Waitlist: "coming soon" chip toggles its inline signup form. */
  function initWaitlists(root) {
    (root || document).querySelectorAll('[data-we-toggle]').forEach(function (btn) {
      if (btn.__weBound) return;
      btn.__weBound = true;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      // Re-open after a successful post (Shopify appends ?customer_posted=true#form-id) or on validation errors.
      if (panel.querySelector('[data-we-wl-success], [aria-invalid="true"]')) {
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      }
      btn.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open) {
          var input = panel.querySelector('input[type="email"]');
          if (input) input.focus();
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initWaitlists(); });
  if (document.readyState !== 'loading') initWaitlists();
  document.addEventListener('shopify:section:load', function (e) { initWaitlists(e.target); });

  /* Sticky add to cart (mobile): proxies the main product form's submit button. */
  if (!customElements.get('we-sticky-atc')) {
    customElements.define('we-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        var SEL = 'product-info product-form button[type="submit"], product-form button[name="add"]';
        this.mainButton = document.querySelector(SEL);
        if (!this.mainButton) return;
        this.hidden = false;
        var self = this;
        var btn = this.querySelector('[data-we-sticky-add]');
        btn.addEventListener('click', function () { self.mainButton.click(); });
        var ticking = false;
        this.update = function () {
          ticking = false;
          // Dawn re-renders the buy buttons on variant change, so look the button up again if needed.
          if (!document.contains(self.mainButton)) self.mainButton = document.querySelector(SEL) || self.mainButton;
          var rect = self.mainButton.getBoundingClientRect();
          // Show the bar once the main Add to cart button has scrolled above the viewport.
          self.classList.toggle('is-visible', rect.bottom < 0);
          btn.disabled = self.mainButton.disabled;
        };
        this.onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(self.update); } };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }
      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }
    });
  }
})();
